
import React from 'react';
import SharedLayout from '@/components/SharedLayout';
import SubpageNavigation from '@/components/SubpageNavigation';

const Eisenhower = () => {
  return (
    <SharedLayout>
      <div className="text-left px-6 py-12 max-w-4xl mx-auto">
        <SubpageNavigation />
        
        <h2 className="text-3xl font-bold mb-6 text-gray-800 dark:text-gray-100">Eisenhower Matrix</h2>
        <p className="mb-6 text-gray-700 dark:text-gray-200">
          The Eisenhower Matrix, also known as the Urgent-Important Matrix, is a decision-making tool that helps 
          you prioritize tasks by urgency and importance, sorting out less urgent and important tasks which you should either delegate or not do at all.
        </p>
        <h3 className="text-2xl font-bold mb-4 text-gray-800 dark:text-gray-100">The Four Quadrants</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          <div className="p-4 bg-red-100 dark:bg-red-900 rounded-lg">
            <h4 className="font-bold text-red-800 dark:text-red-200 mb-2">Quadrant 1: Do First</h4>
            <p className="text-red-700 dark:text-red-300 text-sm mb-2">Urgent & Important</p>
            <p className="text-red-600 dark:text-red-400 text-sm">Crises, emergencies, deadline-driven projects</p>
          </div>
          <div className="p-4 bg-blue-100 dark:bg-blue-900 rounded-lg">
            <h4 className="font-bold text-blue-800 dark:text-blue-200 mb-2">Quadrant 2: Schedule</h4>
            <p className="text-blue-700 dark:text-blue-300 text-sm mb-2">Not Urgent & Important</p>
            <p className="text-blue-600 dark:text-blue-400 text-sm">Prevention, planning, development, recreation</p>
          </div>
          <div className="p-4 bg-yellow-100 dark:bg-yellow-900 rounded-lg">
            <h4 className="font-bold text-yellow-800 dark:text-yellow-200 mb-2">Quadrant 3: Delegate</h4>
            <p className="text-yellow-700 dark:text-yellow-300 text-sm mb-2">Urgent & Not Important</p>
            <p className="text-yellow-600 dark:text-yellow-400 text-sm">Interruptions, some calls, some emails</p>
          </div>
          <div className="p-4 bg-gray-100 dark:bg-gray-700 rounded-lg">
            <h4 className="font-bold text-gray-800 dark:text-gray-200 mb-2">Quadrant 4: Eliminate</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">Not Urgent & Not Important</p>
            <p className="text-gray-600 dark:text-gray-400 text-sm">Time wasters, busy work, some social media</p>
          </div>
        </div>
        <h3 className="text-2xl font-bold mb-4 text-gray-800 dark:text-gray-100">How to Use It</h3>
        <ol className="list-decimal pl-6 mb-8 text-gray-700 dark:text-gray-200">
          <li className="mb-2">List all your tasks and activities</li>
          <li className="mb-2">Categorize each task by urgency and importance</li>
          <li className="mb-2">Place tasks in the appropriate quadrant</li>
          <li className="mb-2">Focus most of your time on Quadrant 2 activities</li>
          <li className="mb-2">Minimize time spent in Quadrants 3 and 4</li>
        </ol>
      </div>
    </SharedLayout>
  );
};

export default Eisenhower;

